import { useEffect } from "react";

export const useBeforeUnload = (
  handleBeforeUnloadEvent: (event: BeforeUnloadEvent) => void,
  preventDefaultEvent = false
) => {
  useEffect(() => {
    const listener = (event: BeforeUnloadEvent) => {
      handleBeforeUnloadEvent(event);
      if (preventDefaultEvent) {
        event.preventDefault();
        // Chrome Browser 지원을 위한 Legacy
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", listener);
    return () => {
      window.removeEventListener("beforeunload", listener);
    };
  }, []);
};
